export const iconFontAwesomeAnimalsFrog = (
	<i className="fa-solid fa-frog"></i>
);
